const actions = {
  REGISTER: 'REGISTER',
  REGISTER_SUCCESS: 'REGISTER_SUCCESS',
  REGISTER_FAILURE: 'REGISTER_FAILURE',

  LOGIN: 'LOGIN',
  LOGIN_SUCCESS: 'LOGIN_SUCCESS',
  LOGIN_FAILURE: 'LOGIN_FAILURE',

  GET_USER_DATA: 'GET_USER_DATA',
  GET_USER_DATA_SUCCESS: 'GET_USER_DATA_SUCCESS',
  GET_USER_DATA_FAILURE: 'GET_USER_DATA_FAILURE',

  UPDATE_USER_DATA: 'UPDATE_USER_DATA',
  UPDATE_USER_DATA_SUCCESS: 'UPDATE_USER_DATA_SUCCESS',
  UPDATE_USER_DATA_FAILURE: 'UPDATE_USER_DATA_FAILURE',

  RESET_PASSWORD: 'RESET_PASSWORD',
  RESET_PASSWORD_SUCCESS: 'RESET_PASSWORD_SUCCESS',
  RESET_PASSWORD_FAILURE: 'RESET_PASSWORD_FAILURE',

  IS_MFA_ENABLED: 'IS_MFA_ENABLED',
  IS_MFA_ENABLED_SUCCESS: 'IS_MFA_ENABLED_SUCCESS',
  IS_MFA_ENABLED_FAILURE: 'IS_MFA_ENABLED_FAILURE',

  SETUP_MFA_AUTHENTICATOR: 'SETUP_MFA_AUTHENTICATOR',
  SETUP_MFA_AUTHENTICATOR_SUCCESS: 'SETUP_MFA_AUTHENTICATOR_SUCCESS',
  SETUP_MFA_AUTHENTICATOR_FAILURE: 'SETUP_MFA_AUTHENTICATOR_FAILURE',

  INITIAL_AUTHORIZE_2FA_CODE: 'INITIAL_AUTHORIZE_2FA_CODE',
  INITIAL_AUTHORIZE_2FA_CODE_SUCCESS: 'INITIAL_AUTHORIZE_2FA_CODE_SUCCESS',
  INITIAL_AUTHORIZE_2FA_CODE_FAILURE: 'INITIAL_AUTHORIZE_2FA_CODE_FAILURE',

  AUTHORIZE_2FA_CODE: 'AUTHORIZE_2FA_CODE',
  AUTHORIZE_2FA_CODE_SUCCESS: 'AUTHORIZE_2FA_CODE_SUCCESS',
  AUTHORIZE_2FA_CODE_FAILURE: 'AUTHORIZE_2FA_CODE_FAILURE',

  VERIFY_2FA_CODE: 'VERIFY_2FA_CODE',
  VERIFY_2FA_CODE_SUCCESS: 'VERIFY_2FA_CODE_SUCCESS',
  VERIFY_2FA_CODE_FAILURE: 'VERIFY_2FA_CODE_FAILURE',

  SEND_EMAIL_CONFIRM_LINK: 'SEND_EMAIL_CONFIRM_LINK',
  SEND_EMAIL_CONFIRM_LINK_SUCCESS: 'SEND_EMAIL_CONFIRM_LINK_SUCCESS',
  SEND_EMAIL_CONFIRM_LINK_FAILURE: 'SEND_EMAIL_CONFIRM_LINK_FAILURE',

  AUTHORIZE_APP: 'AUTHORIZE_APP',

  GET_OPS_USERS: 'GET_OPS_USERS',
  GET_OPS_USERS_SUCCESS: 'GET_OPS_USERS_SUCCESS',
  GET_OPS_USERS_FAILURE: 'GET_OPS_USERS_FAILURE',

  GET_USERS_BY_CLIENT: 'GET_USERS_BY_CLIENT',
  GET_USERS_BY_CLIENT_SUCCESS: 'GET_USERS_BY_CLIENT_SUCCESS',
  GET_USERS_BY_CLIENT_FAILURE: 'GET_USERS_BY_CLIENT_FAILURE',

  CHANGE_PASSWORD: 'CHANGE_PASSWORD',
  CHANGE_PASSWORD_SUCCESS: 'CHANGE_PASSWORD_SUCCESS',
  CHANGE_PASSWORD_FALIURE: 'CHANGE_PASSWORD_FALIURE',

  LOG_OUT: 'LOG_OUT',
  SET_STATE: 'user/SET_STATE',
}

export default actions

export const changePassword = values => {
  return {
    type: actions.CHANGE_PASSWORD,
    values,
  }
}

export const validateMFACode = values => {
  return {
    type: actions.AUTHORIZE_2FA_CODE,
    values,
  }
}

export const getOpsUsers = token => {
  return {
    type: actions.GET_OPS_USERS,
    token,
  }
}

export const getClientUsers = (clientId, token) => {
  return {
    type: actions.GET_USERS_BY_CLIENT,
    clientId,
    token,
  }
}
